enum ProjectLockStatus{
    UNDEFINED,
    LOCK,
    LOCK_OWNED,
    UNLOCK
}

export default ProjectLockStatus;
